
import { mapState, mapGetters } from "vuex";
import SettingsRestaurantStoreAvailability from "../settings/settings-restaurant-store-availability.vue";
import AppReceiverConfigurationItem from "./app-receiver-configuration-item.vue";
import AppReceiverHealthIndexConfiguration from "./app-receiver-health-index-configuration.vue";
export default {
  components: {
    SettingsRestaurantStoreAvailability,
    AppReceiverHealthIndexConfiguration,
    AppReceiverConfigurationItem
  },
  data() {
    return {
      config: {
        autoAccept: false,
        storeAvailability: false,
        orderConfirmation: false,
        hygieneCheck: false,
        printBill: false
      },
      configurationTab: 0,
      selectedRestaurant: {},
      configCopy: {},
      tab: 0
    };
  },

  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    ...mapGetters("restaurant", ["getAllBrands"]),
    hasUnsavedChanges() {
      return JSON.stringify(this.configCopy) !== JSON.stringify(this.config);
    }
  },
  watch: {
    locationDetails() {
      this.handleRestaurantSelection();
    }
  },
  mounted() {
    this.restaurantSelectionChange(0);
    this.configCopy = { ...this.config };
  },
  methods: {
    restaurantSelectionChange(index) {
      this.tab = index;
      this.handleRestaurantSelection();
    },
    handleRestaurantSelection() {
      this.selectedRestaurant = this.locationDetails.restaurants[this.tab];
    }
  }
};
